import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaCircleXmark } from "react-icons/fa6";
import BeatLoader from "react-spinners/BeatLoader";
import { Button, Input } from "../CustomComponents";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import Toast, { ErrorToast, SuccessToast } from "../../Hooks/useToast";
import { useDisputeReasonMutation } from "../../Data/services/disputeApi";

const EditDisputeReason = ({
  handleViewModalClose,
  data,
  handleUpdate,
  updateLoading,
  refetch,
}) => {
  const { handleSubmit, control, setValue } = useForm({});
  const [selectedStatus, setSelectedStatus] = useState("");
  const [userSlug, setUserSlug] = useState("");
  const [disputeReason, { isLoading }] = useDisputeReasonMutation();

  const statusList = [
    { label: "Dispute-Type", value: "dispute-type" },
    { label: "Dispute-Reason", value: "dispute-reason" },
  ];

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (data) {
      setUserSlug(data.id);
      if (data.type === "dispute-reason") {
        setSelectedStatus("Dispute-Reason");
      } else {
        setSelectedStatus("Dispute-Type");
      }
      setValue("name", data.name);
    }
  }, [data, mounted]);

  if (!mounted) {
    return;
  }

  const onSubmit = async (record) => {
    try {
      const payload = {
        id: userSlug,
        ...record,
      };
      const response = await disputeReason(payload);

      if (response?.error?.status === 400) {
        console.log(response?.error?.data?.message);
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response?.error?.status === 500) {
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response.data) {
        SuccessToast(response?.data?.message);
        refetch();
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      }
    }
  };

  return (
    <div>
      <ModalContainer handleClose={handleViewModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-semibold m-0 black-text">Update Reason</p>
            <span className="bg-white bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleViewModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Form onSubmit={handleSubmit(onSubmit)}>
              {
                <Row>
                  <Col md={12}>
                    <p className="m-0 black-text">Name</p>
                    <Controller
                      control={control}
                      name="name"
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Input
                          classes="mt-2 mb-3"
                          type="text"
                          name="name"
                          placeholder="Enter Name"
                          onChange={onChange}
                          value={value}
                        />
                      )}
                    />
                  </Col>
                </Row>
              }
              <Row>
                <Col md={12}>
                  <p className="m-0 black-text">Type</p>
                  <Controller
                    control={control}
                    name="status"
                    rules={{}}
                    defaultValue={selectedStatus}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <SelectFieldComponent
                        firstOption={
                          _.isEmpty(selectedStatus)
                            ? "Select Status"
                            : selectedStatus
                        }
                        optionsList={statusList}
                        onSelectChange={onChange}
                      />
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Button
                    classes={`${cssStyles.cardBtn} mt-4 ${
                      updateLoading ? "bg-white-subtle" : ""
                    }`}
                    text={updateLoading ? <BeatLoader size={10} /> : "Update"}
                    // onClick={handleSubmit}
                    type="Submit"
                  ></Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditDisputeReason;
